import { useEffect } from 'react'

import logger from '@/lib/vouchLogger'
import { debounce } from '@/utils/debounce'

const handleResize = () => {
  logger.info('Browser window sizes', {
    browserWidth: window.innerWidth,
  })
}

const debouncedHandleResize = debounce(handleResize, 150)

const useWindowWidthLogging = () => {
  useEffect(() => {
    debouncedHandleResize() // Also run on initial page load
    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [])
}

export default useWindowWidthLogging
